import React, { useEffect, useState } from 'react'
import HeaderBanner from '../../components/header-banner/HeaderBanner'
import Observatoiredisc from '../../components/ObservatoireDisc/Observatoiredisc'
import Mission from '../../components/mission/Mission'
import Footer from '../../components/footer/Footer'
import ObservList from '../../components/ObservList/ObservList'
import client from '../../client/Client'

const Observatoire = () => {
  const [observatoire, setObservatoire] = useState("")
  useEffect(() => {
    client.fetch('*[_type == "observatoire"]')
    .then((result) => {
      setObservatoire(result)
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
  }, [])
  
  return (
    <div>
        <HeaderBanner  title={"Présentation de "} isHome={false} colored={"L’observatoire"} />
        <Observatoiredisc />
        <Mission />
        <ObservList observatoires={observatoire}  />
        <Footer />
    </div>
  )
}

export default Observatoire